<template>
  <Layout :containers="containers" :fullPage="true">
    <template v-slot:signup-form>
      <Signup
        :isReferralLink="isReferralLink"
        :isActivationLink="isActivationLink"
        :verifyUserLinkCode="verifyUserLinkCode"
        :isPasswordResetLink="isPasswordResetLink"
      />
    </template>
  </Layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AlreadyHaveAnAccount from '../AlreadyHaveAnAccount.vue';
  import Signup from './Signup.vue';
  import Layout from '../../common/layouts/Layout.vue';
  export default {
    name: 'RegisterContainer',
    components: {
      AlreadyHaveAnAccount,
      Signup,
      Layout,
    },
    data() {
      return {
        acceptedTerms: false,
        acceptedCompetitionTerms: false,
        errorMessage: '',
        formRef: null,
        showContent: true,
        ssoSubmitClicked: null,
        interactedWith: 'email',
        stableKey: 'some-stable-key',
      };
    },
    created() {
      dataLayer.push({
        event: 'register_page',
      });
    },
    computed: {
      ...mapGetters(['coBrandCompanyUrl']),
      ...mapGetters(['coBrandCompanyName']),
      ...mapGetters(['bannerTitle']),
      ...mapGetters(['bannerDescription']),
      containers() {
        return [
          {
            name: 'signup-form',
            background: 'countryPattern',
            fadedRow: true,
          },
        ];
      },
    },
    watch: {},
    props: {
      isReferralLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      isActivationLink: {
        required: false,
        default: false,
        type: Boolean,
      },
      verifyUserLinkCode: {
        required: false,
        default: null,
        type: Object,
      },
      isPasswordResetLink: {
        required: false,
        default: false,
        type: Boolean,
      },
    },
    methods: {
      signupMethodFocused(method) {
        this.interactedWith = method;
      },
      signupWithGoogleSsoClicked() {
        this.signupMethodFocused('google');

        this.$nextTick(() => {
          this.$refs.observer.validate().then(valid => {
            if (valid) {
              this.ssoSubmitClicked = Date.now();
            } else {
              const errors = this.$refs.observer.ctx.errors;
              document
                .getElementById(
                  Object.keys(errors).find(field => errors[field].length)
                )
                .scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          });
        });
      },
      loginClicked() {
        this.$emit('loginClicked');
      },
      onError(error) {
        if (!this.acceptedTerms) {
          if (this.$refs.observer) {
            this.$refs.observer.$refs.observer.validate();
          }
          if (this.$refs.signupobserver) {
            this.$refs.signupobserver.$refs.observer.validate();
          }
          if (this.$refs.signupobserverterms) {
            this.$refs.signupobserverterms.$refs.observer.validate();
          }
        }
        if (error) {
          this.errorMessage = error.message
            .replace('GraphQL error:', '')
            .trim();
        } else {
          this.errorMessage = '';
        }
      },
      termsAndConditionsUpdated(accepted) {
        this.acceptedTerms = accepted;
      },
      competitionTermsAndConditionsUpdated(accepted) {
        this.acceptedCompetitionTerms = accepted;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .drawer-signup-container {
    width: 100%;
    padding: 30px;

    .sso-btn {
      margin-bottom: 14px;
    }

    .bottom-section {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .terms-and-conditions-container {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        color: #282828;
        a {
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
          text-align: left;
          color: #282828;
        }
      }
    }

    .title-section {
      h1 {
        font-size: 22px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 10px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 18.2px;
        margin: 0;
      }
    }
    .top-section {
      margin-top: 22px;
    }
    .or-hr-section {
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .error-section {
      p {
        margin: 0;
        margin-top: 16px;
        margin-bottom: 16px;
      }
    }
  }
  .green-text {
    color: #50b848;
    font-weight: bolder;
  }

  @media only screen and (min-width: 0px) and (max-width: 959px) {
    .drawer-signup-container {
      padding-left: 0;
      padding-right: 0;

      .or-hr-section {
        margin-top: 30px;
        margin-bottom: 30px;
      }

      .sso-btn {
        margin-bottom: 14px;
      }
      .already-have-an-account-container {
        margin-top: 14px;
      }
    }
  }
</style>
